/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MoveToAnotherTreatment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import Events from './Events/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TargetTreatment from './TargetTreatment/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MoveToAnotherTreatment({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="MoveToAnotherTreatment.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-3-1y80kC': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Move to another treatment"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="MoveToAnotherTreatment.Vertical"
  data-view-path={viewPath}
 style={{'--mt-4-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="MoveToAnotherTreatment.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<TargetTreatment
  viewPath={`${viewPath}/TargetTreatment`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<Events
  viewPath={`${viewPath}/Events`}
/>
</div>
<div
  data-testid="MoveToAnotherTreatment.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bblr-5-1y80kC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-6-1y80kC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-7-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-8-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-1-1y80kC': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-9-1y80kC': dtColorsWhite,'--btc-10-1y80kC': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}